import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateRequirementOnPosition } from 'api/company/position/requirement'
import { positionsKeys } from 'queries/positions'
import { requirementDataForPositionKey } from './keys'

type Response = Awaited<ReturnType<typeof updateRequirementOnPosition>>
type Variables = Omit<
  Parameters<typeof updateRequirementOnPosition>[0],
  'positionId'
>

export const useUpdateRequirementOnPositionMutation = (positionId?: number) => {
  const queryClient = useQueryClient()
  return useMutation<Response, Error, Variables>({
    mutationFn: ({ requirementId, mustHave }) => {
      if (positionId == null) {
        throw new Error('Position ID is required.')
      }
      return updateRequirementOnPosition({
        positionId,
        requirementId,
        mustHave,
      })
    },
    onSuccess: async () => {
      if (positionId == null) return
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: requirementDataForPositionKey(positionId),
        }),
        queryClient.invalidateQueries({
          queryKey: positionsKeys.detail(positionId),
        }),
      ])
    },
  })
}
